<template>
  <section  id="donation-location-section" >
    <div class="container">
      <div id="container-button-back" class="row container-item-form">
        <div class="col">
          <button
              type="button"
              class="button-section button-back btn"
              @click.prevent="backToDonateBlood"
          >
            <font-awesome-icon :icon="['fas', 'chevron-left']" />
            <span>BACK</span>
          </button>
        </div>
        <div class="col container-distance">
          <div class="row scc-div-page scc-div-left-center">
            <label class="col-auto scc-label-center" for="inputState">Distance:</label>
            <select
                id="inputState"
                class="form-control form-control-sm col"
                v-model.trim="distance"
                v-on:change="changeDonationLocation"
            >
              <option
                  v-for = "(itemDistanceOptions, indexDistanceOptions) in distanceOptions"
                  :key = indexDistanceOptions
                  :value=itemDistanceOptions.value
                  :selected=itemDistanceOptions.selected
              >
                {{ itemDistanceOptions.banner }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div id="container-don-loc-list-title" v-if="siteCustomizationData.messages.donLocListTitle">
        <p style="font-size: 1.05rem; padding-top: 10px;">{{ siteCustomizationData.messages.donLocListTitle }}</p>
      </div>
      <h3
          v-if="showNotEligibilityLocation"
          class="date-block-data-appointments-calendar"
          style="margin-top: 20px;"
      >
        {{ messageNotEligibilityLocation }}
      </h3>
      <div v-else>
        <div class="container-header">
          <div id="container-page-title">
            <h1>Select Your Donation Location</h1>
          </div>
        </div>
        <div id="leaflet-map-container" v-if="(String(lngLocation) !=='0' || String(latLocation) !=='0')">
          <img src="#" class="marker-donation-sites" hidden>
          <div class="out-side-container-map">
            <div class="in-side-container-map" style="position:absolute;top:0;bottom:0;left:0;right:0;">
              <l-map
                  id="map"
                  ref="map"
                  :bounds="mapSettings.bounds"
                  :zoom="mapSettings.zoom"
                  :center="mapSettings.center"
                  :options="{scrollWheelZoom:false}"
              >
                <l-ruler/>
                <l-tile-layer :url="mapSettings.url" :attribution="mapSettings.attribution"></l-tile-layer>
                <l-marker
                    id="marker-donor"
                    :lat-lng="mapSettings.markerLatLng"
                    :icon="mapSettings.icon"
                    :draggable=true
                    ref="markerDonor"
                    @moveend="handleNewCoordinates(mapSettings.markerLatLng);"
                >
                </l-marker>
                <div v-for="(itemMarkersMobileFixed, index) in donationLocation.mapDonationLocation" :key="'marker-' + index">
                  <l-marker
                      class="marker-mobile-fixed test"
                      :lat-lng="itemMarkersMobileFixed.coordinate"
                      ref="markerSite"
                      @click="openPopUp(itemMarkersMobileFixed.coordinate, itemMarkersMobileFixed)"
                      :icon="itemMarkersMobileFixed.iconBlood"
                      v-if="itemMarkersMobileFixed.visibilityDate"
                  >
                    <l-icon>
                      <img :src="itemMarkersMobileFixed.iconUrl" :class="itemMarkersMobileFixed.iconClass"  style="margin-top: -35px; margin-left: -9px;">
                    </l-icon>
                    <l-popup
                        :options="{ offset: [0, 10],}"
                        @close.native="closePopUp"
                    >
                      <div><span><b>Name: </b>{{ itemMarkersMobileFixed.name }}</span></div>
                      <div><span><b>Address: </b>{{ itemMarkersMobileFixed.address }}</span></div>
                      <div><span><b>Distance: </b>{{ itemMarkersMobileFixed.distance }} miles</span></div>
                      <div style = "width: 280px; max-height: 50px; overflow-y: auto;">
                        <div
                            v-for="(itemPopupAppointments, indexPopupAppointments) in itemMarkersMobileFixed.procedures"
                            :key = "indexPopupAppointments"
                        >
                          <div v-if="itemPopupAppointments.status != 'hold'  && showEmptyLocation(itemPopupAppointments.dontAvailable)">
                            <span><b>Date: </b></span>
                            <a :class="[
                              itemPopupAppointments.status == 'scheduled' ? 'scheduledStatusSelect': '',
                              itemPopupAppointments.status == 'closure' ? 'closureStatusSelect': '',
                              {'dont-available': itemPopupAppointments.dontAvailable}
                            ]"
                               href="#"
                               @click=" itemPopupAppointments.status == 'closure' ? openAppointment(itemPopupAppointments.idProfile, /*userInformation.idDonor, */itemPopupAppointments.dontAvailable, 'Temporarily Closed') : openAppointment(itemPopupAppointments.idProfile, /*itemMarkersMobileFixed.idDonor,*/ itemPopupAppointments.dontAvailable, itemPopupAppointments.messageAvailable)" >
                              {{ itemPopupAppointments.date }}
                            </a>
                            <span><b>  Hours: </b></span>{{ itemPopupAppointments.hours }}
                          </div>
                        </div>
                      </div>
                      <div style="width: 100%"><hr/></div>
                      <div style="width: 100%; text-align: center; color: green;"><span>Click date to schedule an appointment.</span></div>
                    </l-popup>
                    <l-tooltip :options="mapSettings.optionsTooltip" >
                      <div><span><b>Name: </b>{{ itemMarkersMobileFixed.name }}</span></div>
                      <div><span><b>Address: </b>{{ itemMarkersMobileFixed.address }}</span></div>
                      <div><span><b>Distance: </b>{{ itemMarkersMobileFixed.distance }} miles</span></div>
                      <div v-for="number in itemMarkersMobileFixed.quantityItems" :key="number">
                        <div
                            v-if="itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].status != 'hold' && showEmptyLocation(itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].dontAvailable)"
                        >
                          <span><b>Date: </b></span><span :class="[
                          itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].status == 'scheduled' ? 'scheduledStatusSelect': '',
                          itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].status == 'closure' ? 'closureStatusSelect': '',
                          {'dont-available': itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].dontAvailable},
                        ]">{{ itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].date }}
                      </span><b>  Hours: </b>{{ itemMarkersMobileFixed.procedures[ parseInt (number) - 1 ].hours }}
                        </div>
                      </div>
                      <div style="width: 100%; text-align: center;"><span><b>{{itemMarkersMobileFixed.contentAfterTooltip}}</b></span></div>
                      <div style="width: 100%"><hr/></div>
                      <div style="width: 100%; text-align: center; color: green;">
                        <span>To schedule an appointment please click on Location Icon</span>
                      </div>
                    </l-tooltip>
                  </l-marker>
                </div>
              </l-map>
            </div>
          </div>
        </div>
        <div
            id="block-appointments-calendar-tab"
            v-if = "visibility.table"
        >
          <div
              class="block-data-appointments-calendar"
              v-for="(dateBlockAppointments, itemNumber) in donationLocation.tabDonationLocation" :key="itemNumber"
          >
            <h3
                class="date-block-data-appointments-calendar"
                v-if="dateBlockAppointments.visibilityDate"
            >
              {{ dateBlockAppointments.date }}
            </h3>
            <table
                class="table table-bordered table-hover"
                v-if="dateBlockAppointments.visibilityDate"
            >
              <thead>
              <tr class="adapt-tr adapt-tr-head">
                <th scope = "col" class="tab-title-center adapt-th" style="width: 5%">Schedule</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 17%">Name</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 29%">Address</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 7%">Type</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 7%">Distance</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 18%">Hours</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 10%">Procedures</th>
                <th scope = "col" class="tab-title-center adapt-th" style="width: 7%">Status</th>

              </tr>
              </thead>
              <tbody>
              <tr
                  class="adapt-tr"
                  v-for="(infoSite, indexInfoSite) in dateBlockAppointments.info" :key="indexInfoSite"
              >
                <td
                    scope="row"
                    class="adapt-td td-icon link-donation-location"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                    @click=" infoSite.status === 'closure' ? openAppointment(infoSite.idProfile, /*userInformation.idDonor,*/ infoSite.dontAvailable, 'Temporarily Closed') : openAppointment(infoSite.idProfile, /*infoSite.idDonor,*/ infoSite.dontAvailable, infoSite.messageAvailable)"
                >
                  <span :class="[{'dont-available': infoSite.dontAvailable} ]">
                    <img :src="infoSite.iconUrl" alt="icon-procedure" />
                  </span>
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  {{ infoSite.Name}}
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  {{ infoSite.Address }}
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  {{ infoSite.Type }}
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  {{ infoSite.Dist }}
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  {{ infoSite.Hours }}
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                    v-html = "infoSite.Procedures "
                >
                </td>
                <td
                    class="adapt-td"
                    v-if="infoSite.status !== 'hold' && showEmptyLocation(infoSite.dontAvailable)"
                >
                  <div class="my-tooltip">
                    <img class="" :src="iconStatusFun(infoSite.status)" style="width: 15px; height: auto;">
                    <div class="my-tooltiptext my-tooltip-top">
                      <div style="vertical-align: inherit;">
                        <div style="vertical-align: inherit;">
                          {{ infoSite.status == 'scheduled' ? 'Scheduled': '' }}
                          {{ infoSite.status == 'closure' ? 'Temporarily Closed': '' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import L from 'leaflet';
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LPopup, LTooltip } from "vue2-leaflet";
import 'leaflet/dist/leaflet.css';
import { mapState } from 'vuex';
import moment from 'moment-timezone';
import LRuler from "vue2-leaflet-ruler";
//import 'leaflet-routing-machine';

export default {
  name: "dbChoiceBloodDonation",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LTooltip,
    LRuler,
  },
  data(){
    return {
      isInitial: true,
      distanceOptions: [],
      distance: this.selectedDistance,

      messageNotEligibilityLocation: '',

      mapSettings: {
        distanceOptionPage: '5',
        zoom: 14,
        center: latLng(47.41322, -1.219482),
        markerLatLng: [47.313220, -1.319482],

        url: 'https://sxpmaps.softcomputer.com/osm5/maps/osm_tiles/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        icon: L.icon({
          iconUrl: this.urlPortal + 'donorportal-vue-dev/src/assets/leafletI/markerIconDonor.png',
          iconSize: [30, 45],
          iconAnchor: [30, 45],
          popupAnchor: [0, -45],
        }),
        optionsTooltip: {
          direction: 'top',
          offset: [0, -45],
          opacity: 1,
        },
        urlRouting: '',
        bounds: null,
        maxBounds: null,
        iconMarkerDonorUrl: this.urlPortal + 'donorportal-vue-dev/src/assets/leafletI/markerIconDonor.png',
        iconMarkerBloodDriveUrl: this.urlPortal +  'donorportal-vue-dev/src/assets/leafletI/markerIconMobile.png',
        iconMarkerFixedSiteUrl: this.urlPortal + 'donorportal-vue-dev/src/assets/leafletI/markerIconFixed.png',
        styleFixedIcon: '',
      },
      iconUrl: {
        fixedSiteTab: '#',
        bloodDriveTab: '#',

      },
      routing: null,
      routingSettings: {
        lang: null,
        unit: null,
        exclude: null,
        factor: null,
        displayRuler: null,
        bannerDisplayRuler: null,
      },
      donationLocation: {
        mapDonationLocation: [],
        tabDonationLocation: {},
      },
      showNotEligibilityLocation: false,
      visibility: {
        map: true,
        table: true,
      }
    }
  },
  computed : {
    ...mapState({
      latLocation: state => state.donateBloodAppointments.dataRequestDonationLocation.lat,
      lngLocation: state => state.donateBloodAppointments.dataRequestDonationLocation.lng,
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
      siteSettingData: state => state.settingsAndCustomize.donorPortalSettings,
      resData: state => state.donateBloodAppointments.dataDonationLocation.responseData,
      idDonor: state => state.donorInformation.idDonor,
      urlPortal: state => state.settingsAndCustomize.configurationSite.urlSite,
      selectedDistance: state => state.donateBloodAppointments.dataRequestDonationLocation.distanceOption,
      arrDistanceOptions: state => state.settingsAndCustomize.siteCustomizationData.appointmentsPage.distanceOptions.arrDistanceOptions,
      entryPointStore: state => state.donateBloodAppointments.entryPoint,
      actionVariableDonateBlood: state => state.donateBloodAppointments.actionVariableDonateBlood,
      prohibitingStatuse: state => state.donorInformation.prohibitingStatuse,
    })
  },
  watch: {
    distance: async function(val){
      const getData = this.$router.currentRoute.query
      if (typeof getData.idApp !== 'undefined') return
      if (this.isInitial){
        this.isInitial = false
        return
      }
      this.$store.commit('donateBloodAppointments/set_donationLocation', {dist: val})

      if(val !== ''){
        this.$root.$emit("showSpinner");
        await this.$store.dispatch('donateBloodAppointments/SET_searchDonationLocation')
        this.processingOfResultsDonationLocation();
        this.$root.$emit("hideSpinner");
      }
    },
  },
  async created() {
    if( this.prohibitingStatuse === '1'){
      this.errorAlert('You are not eligible to donate. Please call the donor room, if you have questions about your eligibility.');
      this.$root.$emit("showSpinner");
      await this.$router.push({name: 'myDonations'})
      this.$root.$emit("hideSpinner");
    }

    this.distanceOptions = this.arrDistanceOptions;
    this.distance = this.selectedDistance;

    this.$store.commit('donateBloodAppointments/set_createBookingTab', '')

    let bodyDomElement = document.querySelector('body')

    this.iconUrl.fixedSiteTab = this.urlPortal
        + 'img/system/portalIcons/fixed_site_tab'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'
    this.iconUrl.bloodDriveTab = this.urlPortal
        + 'img/system/portalIcons/blood_drive_tab'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'

    let laefletRoutingMachineStylesheet = document.createElement('link')
    laefletRoutingMachineStylesheet.setAttribute('type', 'text/css')
    laefletRoutingMachineStylesheet.setAttribute('rel', 'stylesheet')
    laefletRoutingMachineStylesheet.setAttribute('href', this.urlPortal + 'assets/leaflet-and-ruler/leaflet-routing_machine.css')
    bodyDomElement.appendChild(laefletRoutingMachineStylesheet)

    let laefletRoutingMachineScript = document.createElement('script')
    laefletRoutingMachineScript.setAttribute('type', 'text/javascript')
    laefletRoutingMachineScript.setAttribute('src', this.urlPortal + 'assets/leaflet-and-ruler/leaflet-routing_machine.js')
    bodyDomElement.appendChild(laefletRoutingMachineScript)

    this.mapSettings.iconMarkerDonorUrl = this.urlPortal
        + 'img/system/icons/donor'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'
    this.mapSettings.iconMarkerBloodDriveUrl = this.urlPortal
        + 'img/system/icons/blood_drive'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'
    this.mapSettings.iconMarkerFixedSiteUrl = this.urlPortal
        + 'img/system/icons/blood_drive'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'

    this.mapSettings.icon = L.icon({
      iconUrl: this.mapSettings.iconMarkerDonorUrl,
      iconSize: [30, 45],
      iconAnchor:   [30, 45],
      popupAnchor:  [0, -45],
    });

    this.routingSettings.lang = this.$store.getters["settingsAndCustomize/crmSettings"].geoSettings.geoParams.lang
    this.routingSettings.unit = this.$store.getters["settingsAndCustomize/crmSettings"].geoSettings.geoParams.unit
    this.routingSettings.factor = this.$store.getters["settingsAndCustomize/crmSettings"].geoSettings.geoParams.scale
    this.routingSettings.displayRuler = this.$store.getters["settingsAndCustomize/crmSettings"].geoSettings.geoParams.displayRuler
    this.routingSettings.bannerDisplayRuler = this.$store.getters["settingsAndCustomize/crmSettings"].geoSettings.geoParams.labelDisplayRuler

    this.mapSettings.styleFixedIcon = 'background-image: url("'
        + this.urlPortal
        + 'white_back_icon'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png")'

    const getData = this.$router.currentRoute.query
    if (typeof getData.idApp !== 'undefined') {
      this.entryPoint = 'manege'
      this.$store.commit('donateBloodAppointments/set_entryPoint', this.entryPoint)
      this.$store.commit('donateBloodAppointments/set_dataBookingAppointment', {apptId: getData.idApp})
      this.$store.commit('donateBloodAppointments/set_showPage', {
        triggerDonationLocation: true,
      })

      const idProfile = typeof getData.idProfile !== 'undefined' ? getData.idProfile : ''
      const typeProcedure = typeof getData.typeProcedure !== 'undefined' ? getData.typeProcedure : ''

      await this.myDonationsRequestMounted(getData.idApp, idProfile, typeProcedure)
    }


    if (typeof getData.elig !== 'undefined') {
      await this.eligibilityAction(getData)
      this.messageNotEligibilityLocation = this.$store.getters["settingsAndCustomize/messages"]('notFoundDonationLocation').replace('$Procedure', getData.procedureName)
    } else {
      this.messageNotEligibilityLocation = this.$store.getters["settingsAndCustomize/messages"]('notFoundDonationLocation').replace('$Procedure', '')
    }
    await this.processingOfResultsDonationLocation();
  },
  async mounted() {
    document.querySelector('#donation-location-section').style.setProperty("--urlBackgroundIcon", 'url("'
        + this.urlPortal
        + 'img/system/icons/white_back_icon'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png")');
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    backToDonateBlood(){
      this.$router.push({ name: 'donateBlood' })
    },
    async changeDonationLocation(){
/*      const getData = this.$router.currentRoute.query
      if (typeof getData.idApp !== 'undefined') return
      this.$root.$emit("showSpinner");
      this.$store.commit('donateBloodAppointments/set_donationLocation', {dist: this.distance})

      console.log('w0ch distance')
      // eslint-disable-next-line no-unused-vars
      const resDonationLocation = await this.$store.dispatch('donateBloodAppointments/SET_searchDonationLocation')
      this.processingOfResultsDonationLocation();

      this.$root.$emit("hideSpinner");*/
    },
    iconStatusFun(status) {
      switch (status) {
        case 'scheduled':
          return require("../../../assets/iconDonationLocationTab/icons8-Scheduled.png")
        case 'closure':
          return require("../../../assets/iconDonationLocationTab/icons8-temporary-closed.png")
      }
    },
    openPopUp(latLng, caller) {
      this.caller = caller.name;
      var mapObj = this.$refs.map.mapObject;
      mapObj.closePopup();
      if (this.routing != null) {
        mapObj.removeControl(this.routing);
        this.routing = null;
      }
      var defaultTemplate = '<h2>{name}</h2><h3>{distance}, {time}</h3>';
//      let routingUrl = this.$store.getters["settingsAndCustomize/configurationSite"].urlSrtSite + '/index.php?entryPoint=appointment_calendar&action=bookingGeo&OSRM_DIRS=Y';
      let routingUrl = this.$store.getters["settingsAndCustomize/configurationSite"].urlSite + 'api?action=getRoute&entryPoint=appointment_calendar&entryAction=bookingGeo&OSRM_DIRS=Y';
      this.routing = window.L.Routing.control({
        waypoints: [
          window.L.latLng(latLng),
          window.L.latLng(this.latLocation, this.lngLocation)
        ],
        routeWhileDragging: true,
        createMarker: function () {
          return null;
        },
        useHints: false,
        exclude: this.routingSettings.exclude,
        formatter: new window.L.Routing.Formatter({
          language: this.routingSettings.lang,
          units: this.routingSettings.unit,
        }),
        collapsible: true,
        show: false,
        fitSelectedRoutes: false,
        summaryTemplate: '<span class="sasm-dir-remove">Remove</span>' + defaultTemplate,
        router: new window.L.Routing.OSRMv1({
          serviceUrl: routingUrl
        })
      }).addTo(mapObj);
    },
    async openAppointment(idProfile, /*idDonor,*/ dontAvailable, messageAvailable) {
      if (dontAvailable || messageAvailable === 'Temporarily Closed') {
        this.errorAlert(messageAvailable !== '' ? messageAvailable : 'Not available.')
        return
      }
      await this.$store.commit('donateBloodAppointments/set_dataDonationLocation', { profileId: idProfile, })
      await this.$store.commit('donateBloodAppointments/set_showPage',{ triggerBookingAppointment: true })

      this.$router.push({ name: 'dbBookingAppointment' })
    },
    showEmptyLocation(dontAvailable){
      if(this.siteSettingData.hideEmptyLocation && dontAvailable){
        return false
      }
      return true
    },
    processingOfResultsDonationLocation(){

      this.mapSettings.markerLatLng = [this.latLocation, this.lngLocation];

      var resDataSites = this.resData.sites
      const iconsData = this.resData?.icons
      const typesData = this.resData?.types

      //clean data for maps and table
      this.donationLocation.mapDonationLocation.length = 0;
      for (let keyAppDel in this.donationLocation.tabDonationLocation) {
        delete this.donationLocation.tabDonationLocation[keyAppDel]
      }

      let procedure = ''
      let procedureIcons = ''
      let typeDonation = ''
      let affil
      let dontAvailable = true
      let latMin = this.mapSettings.markerLatLng[0]
      let latMax = this.mapSettings.markerLatLng[0]
      let lngMin = this.mapSettings.markerLatLng[1]
      let lngMax = this.mapSettings.markerLatLng[1]
      let hourStart
      let hourEnd
      let pathProcedureIcon
      let select
      let visionMarker = false
      let iconUrl
      let iconUrlTab
      let iconClass

      this.showNotEligibilityLocation = true

      for (let key in resDataSites){
        if (resDataSites[key].parent_type == "Donor_BloodDrives" && resDataSites[key].access != "public") {
          continue;
        }
        if (resDataSites[key].date in this.donationLocation.tabDonationLocation == false) {
          if (this.donationLocation.tabDonationLocation [resDataSites[key].date] === undefined) {
            var fdate = moment(resDataSites[key].date).format('MM/DD/YYYY');
            this.donationLocation.tabDonationLocation[resDataSites[key].date] = {
              date: fdate,
              visibilityDate: false,
              info: []
            };
          }
        }
        hourStart = resDataSites[key].start_time;
        hourEnd = resDataSites[key].end_time;
        procedure = '';
        dontAvailable = true;
        if (resDataSites[key].procedures.length != 0) {
          for (var keyProcedures in resDataSites[key].procedures) {
            if (this.entryPoint === 'manege' && this.actionVariableDonateBlood.varReschedule?.typeProcedure !== keyProcedures) {
                continue
            }
            // I will set this block when I set up the TemporaryManege
            //if (vm.donateBloodInformation.checkTemporaryMenage !== keyProcedures) {
            //  if (vm.donateBloodInformation.checkTemporaryMenage) {
            //    console.log('donateBloodInformation.checkTemporaryMenage == true');
            //    continue;
            //  }
            //}
            // End Block

            pathProcedureIcon =  this.urlPortal + iconsData[keyProcedures] + '?cacheKiller=' + this.$store.getters["settingsAndCustomize/hash"]
            if (resDataSites[key].procedures[keyProcedures]?.max_proc_aptms_online > 0 || !this.siteSettingData.hideZeroProcedures) {
              procedureIcons = '<img src="' + pathProcedureIcon + '" title="' + typesData[keyProcedures] + '"  />';
              if (resDataSites[key].procedures[keyProcedures].available.Online != 0 && resDataSites[key].not_available != true) {
                procedure = procedure + ' <nobr>' + procedureIcons + ' ' + resDataSites[key].procedures[keyProcedures].available.Online + '</nobr>';
                dontAvailable = false;
              } else {
                procedure = procedure + ' <nobr>' + procedureIcons + ' ' + '0 </nobr>'
              }
            }
            if (resDataSites[key].status != 'hold'
                && this.showEmptyLocation(dontAvailable)
                && resDataSites[key].procedures[keyProcedures]?.max_proc_aptms_online > 0 || !this.siteSettingData.hideZeroProcedures
            ) {
              this.donationLocation.tabDonationLocation[resDataSites[key].date].visibilityDate = true;
            }
          }
        }
        switch (resDataSites[key].parent_type) {
          case 'Donor_BloodDrives':
            iconUrl = this.mapSettings.iconMarkerBloodDriveUrl
            iconUrlTab = this.iconUrl.bloodDriveTab
            select = 'ambulance'
            typeDonation = 'Mobile'
            iconClass = 'icon-blood-drivers'
            break;
          case 'Donor_FixedSites':
            iconUrl = this.mapSettings.iconMarkerFixedSiteUrl
            iconUrlTab = this.iconUrl.fixedSiteTab
            select = 'hospital'
            typeDonation = 'Donation Center '
            iconClass = 'icon-fixed-sites'
            break
        }
        this.donationLocation.tabDonationLocation[resDataSites[key].date].info.push({
          Select: select,
          Name: resDataSites[key].name,
          Address: resDataSites[key].addressSum,
          Type: typeDonation,
//          iconUrl: iconUrl,
          iconUrl: iconUrlTab,
          Dist: parseFloat(resDataSites[key].dist).toFixed(2),
          Hours: hourStart + ' - ' + hourEnd,
          Procedures: procedure,
          idProfile: resDataSites[key].id,
          idDonor: this.idDonor,
          dontAvailable: dontAvailable,
          messageAvailable: resDataSites[key].no_availability_message,
          status: resDataSites[key].status,
        })
        /*
        for (var itemProcedure in resDataSites[key].procedures) {
          idProfile = resDataSites[key].procedures[itemProcedure].id
          break;
        }
        */
        affil = false;
        if (this.donationLocation.mapDonationLocation.length !== 0) {
          for (var keyMarker in this.donationLocation.mapDonationLocation) {
            if (this.donationLocation.mapDonationLocation[keyMarker].lat === resDataSites[key].lat && this.donationLocation.mapDonationLocation[keyMarker].lng === resDataSites[key].lng && procedure != '') {
              if (this.donationLocation.mapDonationLocation[keyMarker].quantityItems < 3) {
                let quantity = this.donationLocation.mapDonationLocation[keyMarker].quantityItems;
                this.donationLocation.mapDonationLocation[keyMarker].quantityItems = quantity + 1;

              } else {
                this.donationLocation.mapDonationLocation[keyMarker].contentAfterTooltip = '.......';
              }
              if ( resDataSites[key].status != 'hold' && this.showEmptyLocation(dontAvailable)) {
                visionMarker = true;
                this.donationLocation.mapDonationLocation[keyMarker].visibilityDate = true
                this.showNotEligibilityLocation = false
              }
              for (procedure in resDataSites[key].procedures) {
                if (resDataSites[key].procedures[procedure]?.max_proc_aptms_online > 0 || !this.siteSettingData.hideZeroProcedures) {
                  visionMarker = true;
                }
              }

              this.donationLocation.mapDonationLocation[keyMarker].procedures.push({
                date: fdate,/*resDataSites[key].date,*/
                idProfile: resDataSites[key].id,
                hours: hourStart + ' - ' + hourEnd,
                dontAvailable: dontAvailable,
                messageAvailable: resDataSites[key].no_availability_message,
                status: resDataSites[key].status,
              })
              affil = true;
              break;
            }
          }
        }
        if (affil == false && Number(resDataSites[key].lat) != 0 && Number(resDataSites[key].lng) != 0 && procedure != '') {
          if (resDataSites[key].status != 'hold' && this.showEmptyLocation(dontAvailable)) {
            visionMarker = true;
            this.showNotEligibilityLocation = false
          } else {
            visionMarker = false;
          }

          this.donationLocation.mapDonationLocation.push({
            idDonor: this.idDonor,
            coordinate: [resDataSites[key].lat, resDataSites[key].lng],
            lat: resDataSites[key].lat,
            lng: resDataSites[key].lng,
            iconUrl: iconUrl,
            name: resDataSites[key].name,
            iconClass: iconClass,
            quantityItems: 1,
            contentAfterTooltip: '',
            address: resDataSites[key].addressSum,
            distance: parseFloat(resDataSites[key].dist).toFixed(2),
            visibilityDate: visionMarker,
            iconBlood: L.icon({
              iconUrl: iconUrl,
              iconSize: [30, 45],
              iconAnchor: [15, 45],
              popupAnchor: [0, -45],
              className: 'marker-donation-sites',
              html: '<span style="' + this.mapSettings.styleFixedIcon +'" />'
            }),
            procedures: [
              {
                date: fdate, /*resDataSites[key].date,*/
                idProfile: resDataSites[key].id,
                hours: hourStart + ' - ' + hourEnd,
                dontAvailable: dontAvailable,
                messageAvailable: resDataSites[key].no_availability_message,
                status: resDataSites[key].status,
              },
            ]
          });

          if (Number(resDataSites[key].lat) > Number(latMax) && Number(resDataSites[key].lat) !== 0) {
            latMax = Number(resDataSites[key].lat)
          }
          if (Number(resDataSites[key].lat) < Number(latMin) && Number(resDataSites[key].lat) !== 0) {
            latMin = Number(resDataSites[key].lat)
          }
          if (Number(resDataSites[key].lng) > Number(lngMax) && Number(resDataSites[key].lng) !== 0) {
            lngMax = Number(resDataSites[key].lng)
          }
          if (Number(resDataSites[key].lng) < Number(lngMin) && Number(resDataSites[key].lng) !== 0) {
            lngMin = Number(resDataSites[key].lng)
          }
        }
        this.mapSettings.bounds = L.latLngBounds([[latMin, lngMin], [latMax, lngMax]])
        this.mapSettings.maxBounds = L.latLngBounds([[latMin, lngMin], [latMax, lngMax]])

        this.visibility.map = true
        this.visibility.table = true

      }
    },
    async eligibilityAction(getData){
      this.$store.commit('donateBloodAppointments/set_donationLocation', {eligibility: getData.elig})
      this.$store.commit('donateBloodAppointments/set_showPage', {
        //       triggerBookingAppointment: true,
        triggerDonationLocation: true,
      })
      const dataDeterminationOfCoordinates ={
        zip: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].zip ,
        lat: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].lat,
        lng: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].lng,
      }

      const coordinates = await this.$store.dispatch("donorInformation/SET_determinationOfCoordinates", dataDeterminationOfCoordinates )


      let fromData
      let toData
        if (moment(getData.elig_from_data).isAfter(moment().format('YYYY-MM-DD'))) {
          fromData = moment(getData.elig_from_data).format('MM/DD/YYYY');
        } else {
          fromData = moment().format('MM/DD/YYYY')
        }
        toData = moment(fromData, 'MM/DD/YYYY').clone().add(30, 'days').format('MM/DD/YYYY');

      this.$store.commit('donateBloodAppointments/set_donationLocation', {
        eligibility: getData.elig,
        lat: coordinates.lat,
        lng: coordinates.lng,
        dist: 1000000000,
        distanceOption: '1000000000',
        dateFrom: fromData,
        dateTo: toData,
        siteType: 'all',

      })
      await this.$store.dispatch('donateBloodAppointments/SET_searchDonationLocation')
    },
    async myDonationsRequestMounted(idApp, idProfile = '', typeProcedure = '') {
      const dataDeterminationOfCoordinates ={
        zip: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].zip ,
        lat: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].lat,
        lng: this.$store.getters["donateBloodAppointments/dataRequestDonationLocation"].lng,
      }

      const coordinates = await this.$store.dispatch("donorInformation/SET_determinationOfCoordinates", dataDeterminationOfCoordinates )

      let dataRescheduleAppointment = {
        idApp: idApp,
        coordinates: {
          lat: coordinates.lat,
          lng: coordinates.lng,
        }
      }
      if (idProfile !== ''){
        dataRescheduleAppointment.idProfile = idProfile
      }
      if (typeProcedure !== ''){
        dataRescheduleAppointment.typeProcedure = typeProcedure
      }

      await this.$store.dispatch('donateBloodAppointments/SET_rescheduleAppointment', dataRescheduleAppointment )
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    }
  }
}
</script>

<style>
#donation-location-section{
  --urlBackgroundIcon: url('#');
}
#leaflet-map-container .leaflet-routing-container .leaflet-routing-collapse-btn{
  left: 2px;
  top: 0;
}
.leaflet-routing-collapse-btn{
  text-align: end;
}
.leaflet-routing-alt .sasm-dir-remove{
  color: #ff0000;
}
.marker-donation-sites{
  background-image: var(--urlBackgroundIcon);
  transform: translate3d(580px, 348px, 0px);
  background-size: contain;
  background-repeat: no-repeat;
  width: 30px;
  z-index: 458;
  margin-top: -35px;
  margin-left: -9px;
  outline: none;
  padding: 2px 2px 17px 2px !important;

}
</style>
<style scoped>
#container-button-back{
  text-align: center;
  width:auto;
  align-items: baseline;
  max-width: 100%;
  margin: 10px 0 0 0;
}

#container-button-back div {
  padding-left: 0;
}

#container-don-loc-list-title{
  white-space: pre-wrap;
}

.button-back{
  margin-top: 20px;
  margin-bottom: 0;
}
.label-button{
  margin: 0 15px 0 0;
}
.container-header{
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 15px;
  margin-bottom: 15px;
}
.container-distance{
  padding-right: 0;
  max-width: 200px;
}
.scc-label-center{
  margin-bottom: 0;
}
.scc-div-left-center{
  margin-right: 0;
  align-items: center;
}
#container-page-title{
  display: flex;
}
.out-side-container-map {
  width: 100%;
  padding-bottom: 50%;
  position: relative;
}
.in-side-container-map{
  position: absolute;
  inset: 0;
}
.awesome-icon-tab{
  width: 100%;
  height: auto;
}
#block-appointments-calendar-tab{
  margin-top: 30px;
}
.date-block-data-appointments-calendar{
  font-size: 20px;
  font-weight: bold;
}
.td-icon{
  text-align: center;
}
.td-icon img{
  height: 18px;
}
.link-donation-location{
  cursor: pointer;
}
</style>

